import { create } from 'zustand';
import { AccountApi, ApiUtils, type ChangeCreditLimitResponse, type CreditChangeParams, type StoreBaseReturn } from '@shared/api';

interface UseChangeCreditLimitStore {
  loading: boolean;
  data: ChangeCreditLimitResponse | null;
  error: string | null;
  changeCreditLimit: (searchParams: CreditChangeParams, signal?: AbortSignal) => Promise<StoreBaseReturn<ChangeCreditLimitResponse | null>>;
  clear: () => void;
}

export const useChangeCreditLimitStore = create<UseChangeCreditLimitStore>((set) => ({
  loading: false,
  data: null,
  error: null,

  changeCreditLimit: async (searchParams, signal) => {
    try {
      set({ loading: true, data: null, error: null });
      const result = await AccountApi.changeCreditLimit(searchParams, signal);
      set({ loading: false, data: result || null });
      return { loading: false, data: result || null, error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: null, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
